import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase/firebaseConfig";
import ProductCard from "./ProductCard";
import ProductFilters from "./ProductFilters";

export default function ProductGrid() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [occasions, setOccasions] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedOccasions, setSelectedOccasions] = useState([]);

  useEffect(() => {
    const fetchInventory = async () => {
      const querySnapshot = await getDocs(collection(db, "inventory"));
      const items = querySnapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter(p => p.isActive);

      setProducts(items);

      const categorySet = new Set();
      const occasionSet = new Set();
      items.forEach(item => {
        item.category?.forEach(cat => categorySet.add(cat));
        if (item.occasion) occasionSet.add(item.occasion);
      });

      setCategories([...categorySet]);
      setOccasions([...occasionSet]);
    };

    fetchInventory();
  }, []);

  const toggleItem = (list, setList, item) => {
    if (list.includes(item)) {
      setList(list.filter(x => x !== item));
    } else {
      setList([...list, item]);
    }
  };

  const filteredProducts = products.filter(product => {
    const matchesSearch = product.UITitle?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategories.length === 0 || selectedCategories.some(cat => product.category?.includes(cat));
    const matchesOccasion = selectedOccasions.length === 0 || selectedOccasions.includes(product.occasion);
    return matchesSearch && matchesCategory && matchesOccasion;
  });

  return (
    <>
      <div className="product-filters">
        <ProductFilters
          categories={categories}
          occasions={occasions}
          searchTerm={searchTerm}
          selectedCategories={selectedCategories}
          selectedOccasions={selectedOccasions}
          onSearchChange={setSearchTerm}
          onCategoryToggle={(cat) => toggleItem(selectedCategories, setSelectedCategories, cat)}
          onOccasionToggle={(occ) => toggleItem(selectedOccasions, setSelectedOccasions, occ)}
          onClearFilters={() => {
            setSearchTerm("");
            setSelectedCategories([]);
            setSelectedOccasions([]);
          }}
        />
      </div>
      <h1>Pick a card...Any Card.</h1>
      <p> Start by adding cards from our collection to your cart.</p>
      <div className="product-grid">
        {filteredProducts.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </>
  );
}

